<template>
  <div>正在唤起{{ msg }}登录服务...</div>
</template>

<script>
import mjp from "@/plugins/makjust";
export default {
  name: "BindService",
  data() {
    return {
      msg: "Null",
    };
  },
  methods: {
    authlogin(type) {
      let _Url = "";
      if (type === "qq") {
        _Url =
          "https://graph.qq.com/oauth2.0/show?which=Login&display=pc&client_id=101893306&response_type=token&scope=all&redirect_uri=http%3A%2F%2Flocalhost:8080%2Faccount%2Foauth.php%2Fqq";
      } else {
        return;
      }
      window.open(
        _Url,
        "QQ OAUTH",
        "width=900,height=450,screenX=420,screenY=120,toolbar=no,menubar=no,scrollbars=no,resizable=no,location=no,status=no"
      );
      this.oauthType = type.toUpperCase();
      this.flag_awaitOauth = true;
      //建立窗口回调监听
      window.addEventListener("message", this.awaitLogin);
    },
    awaitLogin(e) {
      //|--获取事件回调消息
      //验证回调来源
      if (e.origin === "https://graph.qq.com") {
        ///QQ///
        QC.Login.getMe((openId, accessToken) => {
          mjp
            .bindOAuth(
              {
                qq: {
                  openid: openId,
                  access_token: accessToken,
                  expires_in: 7776000,
                },
              },
              this.$store.state.USER.sessionToken,
              this.$store.state.USER.objectId,
            )
            .then((r) => {
              this.$store.commit("showSnackbar", {
                type: "success",
                text: "[OAuth]绑定成功",
              });
              this.$store.dispatch("saveUserAsync", r.data);
              this.$router.push("/user/account#oauth");
            })
            .catch((err) => {
              this.$store.commit("showSnackbar", {
                type: "error",
                text: "绑定第三方登录服务时发生了错误。",
              });
            });
        });
      } else {
      }
    },
  },
  mounted() {
    this.msg = this.$route.query.service.toUpperCase();
    this.authlogin(this.$route.query.service);
  },
};
</script>

<style lang="scss" scoped>
</style>